const styles = {
  wrapper: {
    height: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 10px',
    borderBottom: '1px solid #DFE2E5',
    cursor: 'pointer',
    '&:hover': {
      '&>i': {
        transform: 'scale(0.8)',
      },
    },
  },
  text: {
    fontSize: 18,
  },
  icon: {
    display: 'flex',
    transition: ' transform 0.2s ease',
  },
}
export default styles



// WEBPACK FOOTER //
// ./src/Components/Chat/AddConversation/styles.js